// Recovered compiled webpack factory 76293. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "getNextPathnameInfo", {
      enumerable: !0,
      get: function () {
        return i;
      },
    }));
  let n = r(61940),
    a = r(76726),
    o = r(2018);
  function i(e, t) {
    var r, i;
    let { basePath: s, i18n: l, trailingSlash: u } = null != (r = t.nextConfig) ? r : {},
      c = { pathname: e, trailingSlash: "/" !== e ? e.endsWith("/") : u };
    s &&
      (0, o.pathHasPrefix)(c.pathname, s) &&
      ((c.pathname = (0, a.removePathPrefix)(c.pathname, s)), (c.basePath = s));
    let f = c.pathname;
    if (c.pathname.startsWith("/_next/data/") && c.pathname.endsWith(".json")) {
      let e = c.pathname
        .replace(/^\/_next\/data\//, "")
        .replace(/\.json$/, "")
        .split("/");
      ((c.buildId = e[0]),
        (f = "index" !== e[1] ? "/" + e.slice(1).join("/") : "/"),
        !0 === t.parseData && (c.pathname = f));
    }
    if (l) {
      let e = t.i18nProvider
        ? t.i18nProvider.analyze(c.pathname)
        : (0, n.normalizeLocalePath)(c.pathname, l.locales);
      ((c.locale = e.detectedLocale),
        (c.pathname = null != (i = e.pathname) ? i : c.pathname),
        !e.detectedLocale &&
          c.buildId &&
          (e = t.i18nProvider
            ? t.i18nProvider.analyze(f)
            : (0, n.normalizeLocalePath)(f, l.locales)).detectedLocale &&
          (c.locale = e.detectedLocale));
    }
    return c;
  }
}
